<form [formGroup]="formGroup" id="step4Form">
  <div class="step4-form-container">
    <div class="row">
      <div
        *ngIf="controls.inPolandAtApplicationSubmition as inPolandAtApplicationSubmition"
        class="standard-form-field radio-form-field inPolandAtApplicationSubmition-field required-field">
        <label
          id="applicantInPolandAtApplicationSubmitionLabel"
          [class.invalid]="inPolandAtApplicationSubmition.touched && inPolandAtApplicationSubmition.invalid">
          {{ 'IN_POLAND_AT_APPLICATION_SUBMITION.INFIELD-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>

          <!-- TOOLTIP -->
          <app-cr-form-field-tooltip
            [id]="'applicantInPolandAtApplicationSubmitionTooltip'"
            class="info-suffix-icon"
            [text]="'IN_POLAND_AT_APPLICATION_SUBMITION.TOOLTIP' | translate">
          </app-cr-form-field-tooltip>
        </label>

        <mat-radio-group
          id="applicantInPolandAtApplicationSubmitionInput"
          formControlName="inPolandAtApplicationSubmition"
          role="group"
          [attr.aria-labelledby]="'applicantInPolandAtApplicationSubmitionLabel'"
          (keydown)="firstInputKeydown($event)"
          [required]="true"
          [attr.aria-invalid]="
            inPolandAtApplicationSubmition.touched && inPolandAtApplicationSubmition.invalid ? 'true' : null
          ">
          <mat-radio-button [value]="true" id="inPolandAtApplicationSubmition-0">
            {{ 'COMMON.GENERAL.YES' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="false" id="inPolandAtApplicationSubmition-1">
            {{ 'COMMON.GENERAL.NO' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="row" *ngIf="controls.inPolandAtApplicationSubmition.value === true">
      <div
        *ngIf="controls.currentlyLivingInPoland as currentlyLivingInPoland"
        class="standard-form-field radio-form-field currentlyLivingInPoland-field required-field">
        <label
          id="applicantCurrentlyLivingInPolandLabel"
          [class.invalid]="currentlyLivingInPoland.touched && currentlyLivingInPoland.invalid">
          {{ 'PERSONAL_DATA_FORM.RESIDENCE-CURRENTLY-LIVING-IN-POLAND.INFIELD-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>

        <mat-radio-group
          id="applicantCurrentlyLivingInPolandInput"
          formControlName="currentlyLivingInPoland"
          role="group"
          [attr.aria-labelledby]="'applicantCurrentlyLivingInPolandLabel'"
          [attr.aria-invalid]="currentlyLivingInPoland.touched && currentlyLivingInPoland.invalid ? 'true' : null">
          <mat-radio-button [value]="true" id="applicantCurrentlyLivingInPoland-0">
            {{ 'COMMON.GENERAL.YES' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="false" id="applicantCurrentlyLivingInPoland-1">
            {{ 'COMMON.GENERAL.NO' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <ng-container
      *ngIf="
        controls.inPolandAtApplicationSubmition.value === true &&
        (controls.currentlyLivingInPoland.value === true || controls.currentlyLivingInPoland.value === false)
      ">
      <div class="row" aria-live="polite">
        <div
          *ngIf="controls.legalBasisOfStay as legalBasisOfStay"
          class="standard-form-field widened-field legalBasisOfStay-field required-field">
          <label
            id="applicantLegalBasisOfStayLabel"
            [class.invalid]="legalBasisOfStay.touched && legalBasisOfStay.invalid">
            {{
              controls.currentlyLivingInPoland.value === true
                ? ('PERSONAL_DATA_FORM.LEGAL-BASIS-OF-STAY.MAIN-LABEL' | translate)
                : ('PERSONAL_DATA_FORM.PLANNED-LEGAL-BASIS-OF-STAY.MAIN-LABEL' | translate)
            }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>

          <mat-form-field appearance="outline">
            <mat-select
              id="applicantLegalBasisOfStay"
              panelClass="standard-select"
              placeholder=""
              formControlName="legalBasisOfStay"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-labelledby]="'applicantLegalBasisOfStayLabel'"
              [attr.aria-invalid]="legalBasisOfStay.touched && legalBasisOfStay.invalid ? 'true' : null"
              [attr.aria-describedby]="
                legalBasisOfStay.touched && legalBasisOfStay.invalid ? 'applicantLegalBasisOfStayError' : null
              ">
              <mat-option *ngFor="let item of selectsValues.STAY_LEGAL_BASIS" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error id="applicantLegalBasisOfStayError" *ngIf="legalBasisOfStay.touched && legalBasisOfStay.invalid">
              {{ controls.legalBasisOfStay.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div
          *ngIf="controls.residenceVisaExpiryDate as residenceVisaExpiryDate"
          class="standard-form-field residenceVisaExpiryDate-field required-field">
          <label
            for="applicantResidenceVisaExpiryDatePicker"
            [class.invalid]="
              (residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid) ||
              formGroup.errors?.visaExpiredBeforeLastEntryDate
            ">
            {{ 'PERSONAL_DATA_FORM.RESIDENCE-VISA-EXPIRY-DATE.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline" (click)="residenceVisaExpiryDatePicker.open()">
            <input
              matInput
              id="applicantResidenceVisaExpiryDatePicker"
              #applicantResidenceVisaExpiryDatePicker
              readonly
              (focus)="residenceVisaExpiryDatePicker.open()"
              [matDatepicker]="residenceVisaExpiryDatePicker"
              [min]="currentDate"
              [max]="maxValidDocumentExpiryDate"
              placeholder="{{ 'PERSONAL_DATA_FORM.RESIDENCE-VISA-EXPIRY-DATE.PLACEHOLDER' | translate }}"
              formControlName="residenceVisaExpiryDate"
              [attr.aria-describedby]="
                residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid
                  ? 'applicantResidenceVisaExpiryDatePickerError'
                  : null
              " />

            <mat-datepicker-toggle
              matSuffix
              [for]="residenceVisaExpiryDatePicker"
              aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
            </mat-datepicker-toggle>

            <mat-datepicker
              #residenceVisaExpiryDatePicker
              [startView]="'month'"
              [startAt]="currentDate"
              [calendarHeaderComponent]="pickerHeader"
              (closed)="applicantResidenceVisaExpiryDatePicker.blur()">
            </mat-datepicker>

            <!-- ERROR -->
            <mat-error
              id="applicantResidenceVisaExpiryDatePickerError"
              *ngIf="residenceVisaExpiryDate.touched && residenceVisaExpiryDate.invalid">
              {{ residenceVisaExpiryDate.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row" *ngIf="controls.legalBasisOfStay.value === 'inna podstawa'">
        <div
          *ngIf="controls.legalBasisOfStayComment as legalBasisOfStayComment"
          class="standard-form-field widened-field legalBasisOfStayComment-field required-field">
          <label
            for="applicantLegalBasisOfStayComment"
            [class.invalid]="legalBasisOfStayComment.touched && legalBasisOfStayComment.invalid">
            {{ 'PERSONAL_DATA_FORM.LEGAL-BASIS-OF-STAY-COMMENT.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantLegalBasisOfStayComment"
              type="text"
              maxLength="1000"
              minLength="1"
              placeholder=""
              [formControl]="legalBasisOfStayComment"
              [attr.aria-describedby]="
                legalBasisOfStayComment.touched && legalBasisOfStayComment.invalid
                  ? 'applicantLegalBasisOfStayCommentError'
                  : null
              " />

            <!-- ERROR -->
            <mat-error
              id="applicantLegalBasisOfStayCommentError"
              *ngIf="legalBasisOfStayComment.touched && legalBasisOfStayComment.invalid">
              {{ legalBasisOfStayComment.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div
          *ngIf="controls.lastEntryDate as lastEntryDate"
          class="standard-form-field widened-field lastEntryDate-field required-field">
          <label for="applicantLastEntryDate" [class.invalid]="lastEntryDate.touched && lastEntryDate.invalid">
            {{
              controls.currentlyLivingInPoland.value === true
                ? ('PERSONAL_DATA_FORM.LAST-ENTRY-DATE-TEMP-PREMIT.MAIN-LABEL' | translate)
                : ('PERSONAL_DATA_FORM.PLANNED-ENTRY-DATE.MAIN-LABEL' | translate)
            }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline" (click)="lastEntryDatePicker.open()">
            <input
              matInput
              id="applicantLastEntryDate"
              #applicantLastEntryDate
              readonly
              (focus)="lastEntryDatePicker.open()"
              [matDatepicker]="lastEntryDatePicker"
              placeholder="{{ 'PERSONAL_DATA_FORM.LAST-ENTRY-DATE-TEMP-PREMIT.PLACEHOLDER' | translate }}"
              [min]="controls.currentlyLivingInPoland.value === true ? null : currentDate"
              [max]="controls.currentlyLivingInPoland.value === true ? currentDate : null"
              formControlName="lastEntryDate"
              [attr.aria-describedby]="
                lastEntryDate.touched && lastEntryDate.invalid ? 'applicantLastEntryDateError' : null
              " />

            <mat-datepicker-toggle
              matSuffix
              [for]="lastEntryDatePicker"
              aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
            </mat-datepicker-toggle>

            <mat-datepicker
              #lastEntryDatePicker
              [startAt]="currentDate"
              [startView]="'month'"
              [calendarHeaderComponent]="pickerHeader"
              (closed)="applicantLastEntryDate.blur()">
            </mat-datepicker>

            <!-- ERROR -->
            <mat-error id="applicantLastEntryDateError" *ngIf="lastEntryDate.touched && lastEntryDate.invalid">
              {{ lastEntryDate.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>

          <!-- ERROR -->
          <mat-error *ngIf="formGroup.errors?.VISA_EXPIRED_BEFORE_LAST_ENTRY_DATE">
            {{ 'COMMON.VALIDATOR.VISA_EXPIRED_BEFORE_LAST_ENTRY_DATE' | translate }}
          </mat-error>
        </div>
      </div>
    </ng-container>

    <div class="row">
      <div
        *ngIf="controls.noPreviousVisits as noPreviousVisits"
        class="standard-form-field radio-form-field noPreviousVisits-field required-field">
        <label for="applicantNoPreviousVisits" [class.invalid]="noPreviousVisits.touched && noPreviousVisits.invalid">
          {{ 'PERSONAL_DATA_FORM.NO-PREVIOUS-VISITS.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-radio-group
          id="applicantNoPreviousVisits"
          formControlName="noPreviousVisits"
          role="group"
          [required]="true"
          [attr.aria-invalid]="noPreviousVisits.touched && noPreviousVisits.invalid ? 'true' : null">
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="row visits-row" *ngIf="controls.noPreviousVisits.value === false" aria-live="polite">
      <app-previous-visits-form-temp-premit
        [previousVisitsArrFc]="controls.previousVisitsArr"
        [lastEntryDateFc]="controls.lastEntryDate"
        [legalBasisOfStayFc]="controls.legalBasisOfStay"
        [legalBasisOfStayCommentFc]="controls.legalBasisOfStayComment"
        [currentlyLivingInPolandFc]="controls.currentlyLivingInPoland">
      </app-previous-visits-form-temp-premit>
    </div>

    <div class="row">
      <div
        *ngIf="controls.noLastTravelsOutsidePoland as noLastTravelsOutsidePoland"
        class="standard-form-field radio-form-field noLastTravelsOutsidePoland-field required-field">
        <label
          for="applicantNoLastTravelsOutsidePoland"
          [class.invalid]="noLastTravelsOutsidePoland.touched && noLastTravelsOutsidePoland.invalid">
          {{ 'PERSONAL_DATA_FORM.LAST-TRAVELS-OUTSIDE-POLAND.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <!-- IMPORTANT about noLastTravelsOutsidePoland
          there is fuckup because of different label text!
          the field is 'noLastTravelsOutsidePoland' so it would mean that
          if noLastTravelsOutsidePoland === true then user DID NOT have any travels outside poland.
          BUT! !IMPORTANT! current label for this field is: 'Czy przekraczałeś granice krajów innych niż Polska w przeciągu ostatnich 5 lat?'
          so if user marks YES then it means that we have to set our field value to `false` as user DID HAVE TRAVELS OUTSIDE POLAND
        -->
        <mat-radio-group
          id="applicantNoLastTravelsOutsidePoland"
          formControlName="noLastTravelsOutsidePoland"
          role="group"
          (keydown.Tab)="noLastTravelsOutsidePoland.value !== true ? undefined : emitLastFieldTabPressed($event)"
          [required]="true"
          [attr.aria-invalid]="
            noLastTravelsOutsidePoland.touched && noLastTravelsOutsidePoland.invalid ? 'true' : null
          ">
          <mat-radio-button [value]="false"> {{ 'COMMON.GENERAL.YES' | translate }}</mat-radio-button>
          <mat-radio-button [value]="true"> {{ 'COMMON.GENERAL.NO' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <cr-button
        *ngIf="controls.noLastTravelsOutsidePoland.value === false && visitsAmount > 1 && mode === 'employee'"
        class="sort-button"
        [isLoading]="isVisitsSorting"
        [isDisabled]="isVisitsLoading"
        (clicked)="sortClick$.next()">
        {{ 'COUNTRIES_VISITS_FORM.SORT_VISITS' | translate }}
      </cr-button>
    </div>

    <!-- If user HAD LAST TRAVELS OUTSIDE POLAND then display countries-visits-form -->
    <div class="row visits-row" *ngIf="controls.noLastTravelsOutsidePoland.value === false" aria-live="polite">
      <app-countries-visits-form-temp-premit
        [lastTravelsOutsidePoland]="controls.lastTravelsOutsidePoland"
        [triggerSort]="sortClick$"
        (sortingChanged)="onVisitsSortingChange($event)"
        (loadingChanged)="onVisitsLoadingChange($event)"
        (lastFieldTabPressed)="emitLastFieldTabPressed($event)">
      </app-countries-visits-form-temp-premit>
    </div>
  </div>
</form>
